import React from "react";
import { HeartHandshake, Baby, Moon } from "lucide-react";

// Emotional "moments" that show how a couple moves through the journey together.
// Framed as the experience (not attributed quotes) so it stays honest & on-brand.
const MOMENTS = [
  {
    icon: Baby, tag: "First trimester", color: "#E7A6C4",
    line: "\u201cShe's exhausted and queasy today.\u201d",
    body: "He wakes to a gentle cue from Lumi — keep water and a snack close, take a chore off her plate. No guessing. Just showing up.",
  },
  {
    icon: HeartHandshake, tag: "Second trimester", color: "#7A9E7E",
    line: "\u201cBaby can hear your voices now.\u201d",
    body: "They plan the nursery, talk to the bump, and celebrate a scan together — WYVN nudging both of them toward the moments that matter.",
  },
  {
    icon: Moon, tag: "Postpartum", color: "#6AA6FF",
    line: "\u201cThe fourth trimester — she needs you most now.\u201d",
    body: "He takes the night feeds and protects her rest. Lumi keeps a quiet eye out, gently pointing them to their doctor if anything feels off.",
  },
];

export function CoupleStories() {
  return (
    <section id="couple-stories" className="relative mx-auto max-w-6xl px-6 py-24" data-testid="couple-stories">
      <div className="mx-auto max-w-2xl text-center">
        <p className="eyebrow" style={{ color: "#E7A6C4" }}>Two people, one journey</p>
        <h2 className="mt-4 font-display text-4xl font-semibold text-mist sm:text-5xl">Nobody should do this alone</h2>
        <p className="mx-auto mt-4 max-w-lg text-base text-mist-muted">Pregnancy is a team sport. WYVN gives both of you the right words at the right moment — from the first weeks to the fourth trimester.</p>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {MOMENTS.map((m, i) => (
          <div key={m.tag} className="glass group relative overflow-hidden rounded-[1.75rem] p-7" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full blur-[60px] opacity-40 transition-opacity group-hover:opacity-70" style={{ background: m.color }} />
            <div className="relative">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl" style={{ background: `${m.color}22`, color: m.color }}><m.icon size={20} /></span>
              <span className="mt-4 block text-[11px] font-semibold uppercase tracking-wider" style={{ color: m.color }}>{m.tag}</span>
              <p className="mt-2 font-display text-xl font-semibold leading-snug text-mist">{m.line}</p>
              <p className="mt-3 text-sm leading-relaxed text-mist-muted">{m.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
